<ul class="list list-unstyled d-flex mb-0" [ngStyle]="{ gap: '1.25rem' }">
  <ng-container *ngIf="downloadCount !== undefined">
    <ng-container
      *ngTemplateOutlet="
        handleActivity;
        context: {
          width: '1.25rem',
          height: '1.25rem',
          title: 'Downloads',
          svgRef: downloadSVGComponentRef,
          activityCount: (downloadCount | number)
        }
      "
    ></ng-container>
  </ng-container>

  <ng-container *ngIf="saveFileCount !== undefined">
    <ng-container
      *ngTemplateOutlet="
        handleActivity;
        context: {
          width: '1.25rem',
          height: '1.25rem',
          title: 'File Size',
          svgRef: saveSVGComponentRef,
          activityCount: (saveFileCount | formatFileSize)
        }
      "
    ></ng-container>
  </ng-container>

  <ng-container *ngIf="viewCount !== undefined">
    <ng-container
      *ngTemplateOutlet="
        handleActivity;
        context: {
          width: '1.25rem',
          height: '1.25rem',
          title: 'Views',
          svgRef: viewSVGComponentRef,
          activityCount: (viewCount | number)
        }
      "
    ></ng-container>
  </ng-container>

  <ng-container *ngIf="likeCount !== undefined">
    <ng-container
      *ngTemplateOutlet="
        handleActivity;
        context: {
          width: '1.25rem',
          height: '1.25rem',
          title: 'Likes',
          svgRef: likeSVGComponentRef,
          activityCount: (likeCount | number)
        }
      "
    ></ng-container>
  </ng-container>
</ul>

<ng-template
  #handleActivity
  let-width="width"
  let-height="height"
  let-title="title"
  let-svgRef="svgRef"
  let-activityCount="activityCount"
>
  <li class="d-flex align-items-center gap-2">
    <ng-container *ngComponentOutlet="svgRef"></ng-container>
    <span class="text-s">{{ activityCount }}</span>
  </li>
</ng-template>
